export default "__VITE_ASSET__C64rxX7x__"